import React, { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { devDebug } from "@/lib/debug";

// Manages Telegram bot 2-way command webhook (enable/disable + status).
export default function TelegramWebhookPanel() {
  const [status, setStatus] = useState({ active: false, webhook_url: "", bot_token_set: false });
  const [busy, setBusy] = useState(false);
  const load = React.useCallback(async () => {
    try {
      const { data } = await api.get("/telegram/webhook-status");
      setStatus(data);
    } catch (err) {
      devDebug("[TelegramWebhook] status fetch failed:", err);
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const onEnable = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/telegram/register-webhook");
      toast.success("Webhook aktif — bot siap menerima perintah");
      setStatus({ active: true, webhook_url: data.webhook_url, bot_token_set: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  const onDisable = async () => {
    setBusy(true);
    try {
      await api.post("/telegram/unregister-webhook");
      toast.success("Webhook dinonaktifkan");
      setStatus({ active: false, webhook_url: "", bot_token_set: status.bot_token_set });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="border border-border p-3 bg-secondary/30 space-y-2" data-testid="telegram-webhook-panel">
      <div className="flex items-center justify-between gap-2 flex-wrap">
        <div>
          <div className="font-bold text-sm">🤖 Bot Command (2-arah)</div>
          <div className="text-xs text-muted-foreground">
            Aktifkan supaya admin bisa query dari Telegram: <code>/spb 26-00123</code>, <code>/antrian</code>, <code>/mismatch</code>, <code>/help</code>.
          </div>
        </div>
        {status.active ? (
          <Button
            type="button"
            variant="outline"
            className="rounded-xl text-destructive"
            onClick={onDisable}
            disabled={busy}
            data-testid="telegram-webhook-disable"
          >
            Nonaktifkan Webhook
          </Button>
        ) : (
          <Button
            type="button"
            className="rounded-xl font-bold uppercase"
            onClick={onEnable}
            disabled={busy || !status.bot_token_set}
            title={!status.bot_token_set ? "Simpan bot token dulu" : ""}
            data-testid="telegram-webhook-enable"
          >
            {busy ? "Mengatur..." : "Aktifkan Webhook"}
          </Button>
        )}
      </div>
      {status.active && (
        <div className="text-[11px] font-mono bg-emerald-50 border-l-4 border-emerald-500 text-emerald-800 px-3 py-2">
          ✓ Webhook aktif · Bot merespon <code>/spb</code>, <code>/antrian</code>, <code>/mismatch</code>, <code>/help</code>
        </div>
      )}
    </div>
  );
}
